import { get } from "../lib/request";
import moment from "moment";
export const fetchLoginLogs =
  (startDate = moment(), endDate = moment(), skip = 0, limit = 50) => {
    return get(
      `/python/user/login?skip=${skip}&limit=${limit}`, { startdate: startDate, enddate: endDate }
    );
  };
